import React, { Component } from "react";
import { CallAPI, GetCookieFunction, parseIntFromStr } from '../../utils/util';
import { PatientNav } from './patientnav';
import { FunnelNav } from './funnelNav';
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Alert } from 'react-bootstrap';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        let [searchParams] = useSearchParams();
        return <Component {...props} router={{ location, navigate, params, searchParams }} />;
    }
    return ComponentWithRouterProp;
}

class SurgicalHistory extends Component {
    constructor(props) {
        super(props);
        this.patient_id = parseIntFromStr(this.props.router.params.patientId);
        this.user_type = (GetCookieFunction("User")?.type === "doctor") ? "doctor" : "nurse";
        this.funnel = this.props.router.searchParams.get('funnel') ? "?funnel=1" : "";
        this.state = { rows: [], patientID: this.patient_id };
    }

    componentDidMount() {
        CallAPI({}, `patients/${this.patient_id}/surgeries`, 'GET', (res) => {
            this.setState({ rows: res.length > 0 ? res : [] });
        });
    }

    onAddRow = () => {
        this.setState({ rows: [...this.state.rows, { id: 0, info: "", year: "", delete: false }] });
    };

    onDeleteRow = (index) => {
        this.setState({
            rows: this.state.rows.map((row, i) => i === index ? { ...row, delete: true } : row)
        });
    };

    onFieldChange = (index, field, value) => {
        this.setState({
            rows: this.state.rows.map((row, i) => i === index ? { ...row, [field]: value } : row)
        });
    };

    onSave = () => {
        if (this.state.rows.length === 0) {
            if (this.funnel) this.props.router.navigate(`/patients/${this.patient_id}/assessmentPlan${this.funnel}`);
            return;
        }
        CallAPI(this.state, `patients/${this.patient_id}/surgeries`, 'PUT', () => {
            if (this.funnel) {
                this.props.router.navigate(`/patients/${this.patient_id}/assessmentPlan${this.funnel}`);
            } else {
                CallAPI({}, `patients/${this.patient_id}/surgeries`, 'GET', (res) => {
                    this.setState({
                        rows: res.length > 0 ? res : [],
                        modalVariant: "success",
                        modalMessage: "Surgical history saved successfully."
                    });
                });
            }
        }, () => {
            this.setState({ modalVariant: "danger", modalMessage: "Could not save surgical history." });
        });
    };

    render = () => {
        const visibleRows = this.state.rows.filter(r => !r.delete);

        return (
            <div>
                <PatientNav patientId={this.patient_id} />

                <div className="ci-page">
                    {this.funnel && <FunnelNav patientId={this.patient_id} currentStep={7} />}
                    <div className="ci-header">
                        <h2>Surgical History</h2>
                        <p>Record past surgical procedures for this patient</p>
                    </div>

                    {this.state.modalVariant && (
                        <Alert variant={this.state.modalVariant} className="ci-alert">
                            {this.state.modalMessage}
                        </Alert>
                    )}

                    <div className="editable-table-wrap">
                        {/* Desktop header */}
                        <div className="editable-table-header surg-row">
                            <div className="editable-col-surg-name">Procedure / Surgery</div>
                            <div className="editable-col-surg-year">Year Performed</div>
                            <div className="editable-col-action"></div>
                        </div>

                        {visibleRows.length === 0 ? (
                            <div className="editable-empty">
                                No surgical history on file. Click "Add Record" to add one.
                            </div>
                        ) : (
                            visibleRows.map((row, i) => {
                                const realIndex = this.state.rows.indexOf(row);
                                return (
                                    <div key={i} className="editable-table-row surg-row">
                                        <div className="editable-col-surg-name">
                                            <label className="med-mobile-label">Procedure</label>
                                            <input
                                                type="text"
                                                placeholder="e.g. AV Fistula creation"
                                                value={row.info}
                                                onChange={(e) => this.onFieldChange(realIndex, 'info', e.target.value)}
                                            />
                                        </div>
                                        <div className="editable-col-surg-year">
                                            <label className="med-mobile-label">Year</label>
                                            <input
                                                type="text"
                                                placeholder="e.g. 2021"
                                                maxLength="4"
                                                pattern="[\d]{4}"
                                                title="4-digit year"
                                                value={row.year}
                                                onChange={(e) => this.onFieldChange(realIndex, 'year', e.target.value)}
                                            />
                                        </div>
                                        <div className="editable-col-action">
                                            <button
                                                type="button"
                                                className="editable-delete-btn"
                                                onClick={() => this.onDeleteRow(realIndex)}
                                                aria-label="Delete"
                                            >✕</button>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>

                    <div className="editable-actions">
                        <button type="button" className="homeButton" onClick={this.onAddRow}>
                            + Add Record
                        </button>
                        <button type="button" className="logSubmit" onClick={this.onSave}
                            style={{ width: 'auto', marginTop: 0 }}>
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        );
    };
}

export default withRouter(SurgicalHistory);
